function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/tablecellproperties/tablecellpropertiesediting
 */
import { Plugin } from 'ckeditor5/src/core';
import { addBorderRules, addPaddingRules, addBackgroundRules } from 'ckeditor5/src/engine';
import { downcastAttributeToStyle, upcastStyleToAttribute, upcastBorderStyles } from './../converters/tableproperties';
import TableEditing from './../tableediting';
import TableCellPaddingCommand from './commands/tablecellpaddingcommand';
import TableCellWidthCommand from './commands/tablecellwidthcommand';
import TableCellHeightCommand from './commands/tablecellheightcommand';
import TableCellBackgroundColorCommand from './commands/tablecellbackgroundcolorcommand';
import TableCellVerticalAlignmentCommand from './commands/tablecellverticalalignmentcommand';
import TableCellHorizontalAlignmentCommand from './commands/tablecellhorizontalalignmentcommand';
import TableCellBorderStyleCommand from './commands/tablecellborderstylecommand';
import TableCellBorderColorCommand from './commands/tablecellbordercolorcommand';
import TableCellBorderWidthCommand from './commands/tablecellborderwidthcommand';
import { getNormalizedDefaultProperties } from '../utils/table-properties';
var VALIGN_VALUES_REG_EXP = /^(top|middle|bottom)$/;
var ALIGN_VALUES_REG_EXP = /^(left|center|right|justify)$/;
/**
 * The table cell properties editing feature.
 *
 * Introduces table cell model attributes and their conversion:
 *
 * - border: `borderStyle`, `borderColor` and `borderWidth`
 * - background color: `backgroundColor`
 * - cell padding: `padding`
 * - horizontal and vertical alignment: `horizontalAlignment`, `verticalAlignment`
 * - cell width and height: `width`, `height`
 *
 * It also registers commands used to manipulate the above attributes:
 *
 * - border: the `'tableCellBorderStyle'`, `'tableCellBorderColor'` and `'tableCellBorderWidth'` commands
 * - background color: the `'tableCellBackgroundColor'` command
 * - cell padding: the `'tableCellPadding'` command
 * - horizontal and vertical alignment: the `'tableCellHorizontalAlignment'` and `'tableCellVerticalAlignment'` commands
 * - width and height: the `'tableCellWidth'` and `'tableCellHeight'` commands
 *
 * @extends module:core/plugin~Plugin
 */

var TableCellPropertiesEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(TableCellPropertiesEditing, _Plugin);

  var _super = _createSuper(TableCellPropertiesEditing);

  function TableCellPropertiesEditing() {
    _classCallCheck(this, TableCellPropertiesEditing);

    return _super.apply(this, arguments);
  }

  _createClass(TableCellPropertiesEditing, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var editor = this.editor;
      var schema = editor.model.schema;
      var conversion = editor.conversion;
      editor.config.define('table.tableCellProperties.defaultProperties', {});
      var defaultTableCellProperties = getNormalizedDefaultProperties(editor.config.get('table.tableCellProperties.defaultProperties'), {
        includeVerticalAlignmentProperty: true,
        includeHorizontalAlignmentProperty: true,
        includePaddingProperty: true,
        isRightToLeftContent: editor.locale.contentLanguageDirection === 'rtl'
      });
      editor.data.addStyleProcessorRules(addBorderRules);
      enableBorderProperties(schema, conversion, {
        color: defaultTableCellProperties.borderColor,
        style: defaultTableCellProperties.borderStyle,
        width: defaultTableCellProperties.borderWidth
      });
      editor.commands.add('tableCellBorderStyle', new TableCellBorderStyleCommand(editor, defaultTableCellProperties.borderStyle));
      editor.commands.add('tableCellBorderColor', new TableCellBorderColorCommand(editor, defaultTableCellProperties.borderColor));
      editor.commands.add('tableCellBorderWidth', new TableCellBorderWidthCommand(editor, defaultTableCellProperties.borderWidth));
      enableHorizontalAlignmentProperty(schema, conversion, defaultTableCellProperties.horizontalAlignment);
      editor.commands.add('tableCellHorizontalAlignment', new TableCellHorizontalAlignmentCommand(editor, defaultTableCellProperties.horizontalAlignment));
      enableProperty(schema, conversion, {
        modelAttribute: 'width',
        styleName: 'width',
        defaultValue: defaultTableCellProperties.width
      });
      editor.commands.add('tableCellWidth', new TableCellWidthCommand(editor, defaultTableCellProperties.width));
      enableProperty(schema, conversion, {
        modelAttribute: 'height',
        styleName: 'height',
        defaultValue: defaultTableCellProperties.height
      });
      editor.commands.add('tableCellHeight', new TableCellHeightCommand(editor, defaultTableCellProperties.height));
      editor.data.addStyleProcessorRules(addPaddingRules);
      enableProperty(schema, conversion, {
        modelAttribute: 'padding',
        styleName: 'padding',
        reduceBoxSides: true,
        defaultValue: defaultTableCellProperties.padding
      });
      editor.commands.add('tableCellPadding', new TableCellPaddingCommand(editor, defaultTableCellProperties.padding));
      editor.data.addStyleProcessorRules(addBackgroundRules);
      enableProperty(schema, conversion, {
        modelAttribute: 'backgroundColor',
        styleName: 'background-color',
        defaultValue: defaultTableCellProperties.backgroundColor
      });
      editor.commands.add('tableCellBackgroundColor', new TableCellBackgroundColorCommand(editor, defaultTableCellProperties.backgroundColor));
      enableVerticalAlignmentProperty(schema, conversion, defaultTableCellProperties.verticalAlignment);
      editor.commands.add('tableCellVerticalAlignment', new TableCellVerticalAlignmentCommand(editor, defaultTableCellProperties.verticalAlignment));
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'TableCellPropertiesEditing';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [TableEditing];
    }
  }]);

  return TableCellPropertiesEditing;
}(Plugin); // Enables the `'borderStyle'`, `'borderColor'` and `'borderWidth'` attributes for table cells.
//
// @param {module:engine/model/schema~Schema} schema
// @param {module:engine/conversion/conversion~Conversion} conversion
// @param {Object} defaultBorder The default border values.
// @param {String} defaultBorder.color The default `borderColor` value.
// @param {String} defaultBorder.style The default `borderStyle` value.
// @param {String} defaultBorder.width The default `borderWidth` value.


export { TableCellPropertiesEditing as default };

function enableBorderProperties(schema, conversion, defaultBorder) {
  schema.extend('tableCell', {
    allowAttributes: ['borderWidth', 'borderColor', 'borderStyle']
  });
  upcastBorderStyles(conversion, 'td', defaultBorder);
  upcastBorderStyles(conversion, 'th', defaultBorder);
  downcastAttributeToStyle(conversion, {
    modelElement: 'tableCell',
    modelAttribute: 'borderStyle',
    styleName: 'border-style'
  });
  downcastAttributeToStyle(conversion, {
    modelElement: 'tableCell',
    modelAttribute: 'borderColor',
    styleName: 'border-color'
  });
  downcastAttributeToStyle(conversion, {
    modelElement: 'tableCell',
    modelAttribute: 'borderWidth',
    styleName: 'border-width'
  });
} // Enables the `'horizontalAlignment'` attribute for table cells.
//
// @param {module:engine/model/schema~Schema} schema
// @param {module:engine/conversion/conversion~Conversion} conversion
// @param {module:utils/locale~Locale} locale The {@link module:core/editor/editor~Editor#locale} instance.
// @param {String} defaultValue The default horizontal alignment value.


function enableHorizontalAlignmentProperty(schema, conversion, defaultValue) {
  schema.extend('tableCell', {
    allowAttributes: ['horizontalAlignment']
  });
  conversion.for('downcast').attributeToAttribute({
    model: {
      name: 'tableCell',
      key: 'horizontalAlignment'
    },
    view: function view(alignment) {
      return {
        key: 'style',
        value: {
          'text-align': alignment
        }
      };
    }
  });
  conversion.for('upcast') // Support for the `text-align:*;` CSS definition for the table cell alignment.
  .attributeToAttribute({
    view: {
      name: /^(td|th)$/,
      styles: {
        'text-align': ALIGN_VALUES_REG_EXP
      }
    },
    model: {
      key: 'horizontalAlignment',
      value: function value(viewElement) {
        var align = viewElement.getStyle('text-align');
        return align === defaultValue ? null : align;
      }
    }
  }) // Support for the `align` attribute as the backward compatibility while pasting from other sources.
  .attributeToAttribute({
    view: {
      name: /^(td|th)$/,
      attributes: {
        align: ALIGN_VALUES_REG_EXP
      }
    },
    model: {
      key: 'horizontalAlignment',
      value: function value(viewElement) {
        var align = viewElement.getAttribute('align');
        return align === defaultValue ? null : align;
      }
    }
  });
} // Enables the `'verticalAlignment'` attribute for table cells.
//
// @param {module:engine/model/schema~Schema} schema
// @param {module:engine/conversion/conversion~Conversion} conversion
// @param {String} defaultValue The default vertical alignment value.


function enableVerticalAlignmentProperty(schema, conversion, defaultValue) {
  schema.extend('tableCell', {
    allowAttributes: ['verticalAlignment']
  });
  conversion.for('downcast').attributeToAttribute({
    model: {
      name: 'tableCell',
      key: 'verticalAlignment'
    },
    view: function view(alignment) {
      return {
        key: 'style',
        value: {
          'vertical-align': alignment
        }
      };
    }
  });
  conversion.for('upcast') // Support for the `vertical-align:*;` CSS definition for the table cell alignment.
  .attributeToAttribute({
    view: {
      name: /^(td|th)$/,
      styles: {
        'vertical-align': VALIGN_VALUES_REG_EXP
      }
    },
    model: {
      key: 'verticalAlignment',
      value: function value(viewElement) {
        var align = viewElement.getStyle('vertical-align');
        return align === defaultValue ? null : align;
      }
    }
  }) // Support for the `align` attribute as the backward compatibility while pasting from other sources.
  .attributeToAttribute({
    view: {
      name: /^(td|th)$/,
      attributes: {
        valign: VALIGN_VALUES_REG_EXP
      }
    },
    model: {
      key: 'verticalAlignment',
      value: function value(viewElement) {
        var valign = viewElement.getAttribute('valign');
        return valign === defaultValue ? null : valign;
      }
    }
  });
} // Enables conversion for an attribute for simple view-model mappings.
//
// @param {module:engine/model/schema~Schema} schema
// @param {module:engine/conversion/conversion~Conversion} conversion
// @param {Object} options
// @param {String} options.modelAttribute
// @param {String} options.styleName
// @param {String} options.defaultValue The default value for the specified `modelAttribute`.
// @param {Boolean} [options.reduceBoxSides=false]


function enableProperty(schema, conversion, options) {
  var modelAttribute = options.modelAttribute;
  schema.extend('tableCell', {
    allowAttributes: [modelAttribute]
  });
  upcastStyleToAttribute(conversion, _objectSpread({
    viewElement: /^(td|th)$/
  }, options));
  downcastAttributeToStyle(conversion, _objectSpread({
    modelElement: 'tableCell'
  }, options));
}